import { SpineBase, ingenuity, Container, dispatcher, Graphics } from "@quest/base-core/dist";
import { Model as platformModel } from "@quest/platform-murka-phase_2/dist/Model/Model";
import { BaseGameView } from "@quest/slot-core";

import { StackSymbolView } from "./StackSymbolView";
import { eventDispatchers } from "../Constants/EventDispatchers";
import { gameConstants } from "../Constants/gameConstants";
import { GameParserModel } from "../Platform/GameParserModel";
import { SoundConstantGame } from "../Constants/SoundConstantGame";
import { SlotConstantsBehavior } from "@quest/murka-games-behavior-panther";

export class StackSymbolController {
  private view: StackSymbolView;
  protected baseGameView: BaseGameView;
  private stackSymbolContainer: Container;

  constructor(view: StackSymbolView, baseGameView: BaseGameView) {
    this.view = view;
    this.baseGameView = baseGameView;
    this.initializeElements();
    this.subscribeEvents();
  }

  /**
   * Initialize Elements
   */
  private initializeElements(): void {
    this.stackSymbolContainer = this.view.getContainerByID("stackSymbolMainConatiner");
    (this.stackSymbolContainer.mask as Graphics) = this.view.getShapeById("stackSymbolMask");
  }

  /**
   * Subscribe events
   */
  private subscribeEvents(): void {
    this.unsubscribeEvents();
    dispatcher.on(eventDispatchers.START_STACK_SYMBOL_WIN_ANIMATION, this.alignStackSymbol, this);
    dispatcher.on(eventDispatchers.HIDE_STACK_SYMBOL_WIN_ANIMATION, this.hideStackSymbol, this);
  }

  /**
   * Unsubscribe events
   */
  private unsubscribeEvents(): void {
    dispatcher.off(eventDispatchers.START_STACK_SYMBOL_WIN_ANIMATION, this.alignStackSymbol, this);
    dispatcher.off(eventDispatchers.HIDE_STACK_SYMBOL_WIN_ANIMATION, this.hideStackSymbol, this);
  }

  /**
   * Add to align stack symbols win animation
   */
  private alignStackSymbol(): void {
    const reelGrid: number[][] = (ingenuity.parserModel as platformModel).getReelGrid();
    let stackData: number[][] = gameConstants.MAN_AND_LADY_STACK_DATA;
    stackData.forEach((value: number[]) => {
      for (let i = 0; i < reelGrid.length; i++) {
        for (let j = 0; j < reelGrid[i].length; j++) {
          if (reelGrid[i][j] === value[2]) {
            const top: number = 0;
            const stackTopSpine: SpineBase = this.alignSpine(i, top, j, value[2]);
            const topOffSet: number[][] = this.setOffset(i, j, reelGrid[i].length, value[1]);
            this.playStackAnimation(topOffSet, stackTopSpine, value[1]);
            for (let k = j + value[1]; k < reelGrid[i].length; k++) {
              if (reelGrid[i][k] === value[2]) {
                const bottom: number = 1;
                const stackBottomSpine: SpineBase = this.alignSpine(i, bottom, k, value[2]);
                const bottomOffSet: number[][] = this.setOffset(i, k, reelGrid[i].length, value[1]);
                this.playStackAnimation(bottomOffSet, stackBottomSpine, value[1]);
                break;
              }
            }
            break;
          }
        }
      }
    }, this);
  }

  /**
   * Allign Spine
   */
  private alignSpine(reelId: number, childNumber: number, symIndex: number, stackId: number): SpineBase {
    let selectedStack;
    if (stackId === gameConstants.MAN_SYMBOL_1X3_STACK_ID || stackId === gameConstants.MAN_SYMBOL_1X5_STACK_ID) {
      selectedStack = "Man";
    }
    const stackSpineContainer: Container = this.view.getContainerByID("reelConatiner_" + selectedStack + "_" + reelId);
    const stackSpine: SpineBase = stackSpineContainer.children[childNumber];
    stackSpine.y = this.view.json.stackSymbolYArray[symIndex];
    stackSpine.visible = false;
    return stackSpine;
  }

  /**
   * Add to play stack symbol animation
   */
  private playStackAnimation(StackOffset: number[][], stackAnimation: SpineBase, stackSize: number): void {
    let winDataOffSet = (ingenuity.parserModel as platformModel).getWinLinesData()[
      (ingenuity.parserModel as platformModel).getWinLinesData().length -
      (ingenuity.parserModel as GameParserModel).getCascadeLineToggleCount()
    ].positions;
    // let winDataOffSet = (ingenuity.parserModel as platformModel).getLinesWinAllUniquePositions();
    let flag: boolean = false;
    for (let offset of StackOffset) {
      for (let winOffset of winDataOffSet) {
        if (offset[0] === winOffset[0] && offset[1] === winOffset[1]) {
          flag = true;
          break;
        }
      }
    }
    if (flag === true) {
      (ingenuity.soundManager as any).playSound(SoundConstantGame.CHARACTER_WIN_SOUND, SlotConstantsBehavior.SOUND_LIST_PRELOAD);
      stackAnimation.visible = true;
      stackAnimation.setPause(false);
      const stackAnim: string = "symbol_character_1x" + stackSize;
      stackAnimation.playAnim(stackAnim, true);
    }
  }

  /**
   * Set stack symbol win offset
   */
  private setOffset(reelId: number, symIndex: number, reelGridLength: number, stackSize: number): number[][] {
    let offset: number[][] = [];
    for (let index = symIndex; index < reelGridLength; index++) {
      const pos: number[] = [reelId, index];
      offset.push(pos);
      if (offset.length === stackSize) {
        break;
      }
    }
    return offset;
  }

  /**
   * Add to hide stack symbol
   */
  private hideStackSymbol(): void {
    this.stackSymbolContainer.forEach((child: Container) => {
      child.forEach((reelConatiner: Container) => {
        reelConatiner.forEach((stackSpine: SpineBase) => {
          stackSpine.visible = false;
          stackSpine.setPause(true);
        }, this);
      }, this);
    }, this);
  }
}
